import { messages, intl } from '../messages';
import { actions as operatorsActions } from 'src/redux/data/operators';

export const operatorsErrorNotificationMessagesMap = {
  [operatorsActions.createOperator.type]: (_, err) => ({
    message: intl.formatMessage(messages.createOperatorError),
    description: err || '',
  }),

  [operatorsActions.editOperator.type]: (_, err) => ({
    message: intl.formatMessage(messages.editOperatorError),
    description: err || '',
  }),
};

export const operatorsSuccessNotificationMessagesMap = {
  [operatorsActions.createOperator.type]: operatorName => ({
    message: `${operatorName} ${intl.formatMessage(messages.createOperatorSuccess)}`,
  }),
  [operatorsActions.editOperator.type]: operatorName => ({
    message: `${operatorName} ${intl.formatMessage(messages.editOperatorSuccess)}`,
  }),
};
